import { useMemo } from 'react'
import { CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import MyTable from '../MyTable/MyTable'
import SortItems from '../MyTable/SortItems'
import { object, func, string, number, bool, arrayOf, shape } from 'prop-types'

const styles = makeStyles((theme) => ({
  centerDiv: {
    margin: 'auto',
    padding: '10px',
    textAlign: 'center',
  },
  spinner: {
    color: theme.palette.primary.main,
  },
  leftDiv: {
    fontSize: 16,
    padding: '1px',
    margin: '1px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  iconStyle: {
    width: '36px',
    height: '36px',
  },
}))

const MessageTemplateItems = (props) => {
  const classes = styles(props)
  const {
    dataFromParent,
    fetchingState,
    callbackFromParentSelections,
    callbackFromParentSelectData,
    selectionsFromParent,
  } = props

  var tempData = []

  const columns = useMemo(
    () => [
      {
        Header: ' ',
        columns: [
          {
            Header: 'Message Template Name',
            accessor: 'message_title',
            sortType: (prev, curr, columnId) => {
              return SortItems(prev, curr, columnId)
            },
          },
        ],
      },
    ],
    [],
  )

  // pass only array data
  if (dataFromParent !== null) {
    tempData = dataFromParent
  }

  if (fetchingState) {
    return (
      <div className={classes.centerDiv}>
        <CircularProgress className={classes.spinner} thickness={7} />
        <h3>loading...</h3>
      </div>
    )
  } else {
    return (
      <MyTable
        columns={columns}
        data={tempData}
        defaultPageSize={10} // You can set this to any default
        defaultPageIndex={0}
        maxPageCount={Math.ceil(tempData.length / 10)} // calculate based on data
        onPageSizeChange={(pageSize, pageIndex) => {
          console.log('Page size changed:', pageSize, 'Page index:', pageIndex)
        }}
        onPageChange={(pageIndex) => {
          console.log('Page changed to:', pageIndex)
        }}
        defaultSortColumn={[
          {
            id: 'message_title',
            desc: false,
          },
        ]}
        useRadioSelection={true}
        onRowSelectChange={(rowsSelected) => {
          callbackFromParentSelections(rowsSelected)
        }}
        onFlatRowSelectChange={(rowsSelected) => {
          callbackFromParentSelectData(rowsSelected)
        }}
        defaultSelectedRows={selectionsFromParent}
      />
    )
  }
}

export default MessageTemplateItems

MessageTemplateItems.propTypes = {
  dataFromParent: arrayOf(
    shape({
      message_title: string,
    }),
  ),
  fetchingState: bool.isRequired,
  pageFromParent: number,
  pageSizeFromParent: number,
  callbackFromParentSelections: func.isRequired,
  callbackFromParentSelectData: func.isRequired,
  selectionsFromParent: object,
}
